/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Drastic_Tech_Stdout_LogInputs */



/**
* | output |
* | --- |
* | "[DRASTIC stdout]: {message}" |
*
* @param {Drastic_Tech_Stdout_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_stdout_log = /** @type {((inputs: Drastic_Tech_Stdout_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Stdout_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`[DRASTIC stdout] : ${i?.message}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`[DROSTIC stdout]: ${i?.message}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`[Stdout DRASTICO]: ${i?.message}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`[DRASTIC stdout]: ${i?.message}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`[Salida estándar DRASTIC]: ${i?.message}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`[DRASTIC 标准输出]: ${i?.message}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`[DRASTIC 標準出力]: ${i?.message}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`[DRASTIC stdout]: ${i?.message}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`[Saída padrão DRASTIC]: ${i?.message}`)
	return /** @type {LocalizedString} */ (`[DRASTIC stdout]: ${i?.message}`)
});